import MonitorDashboard from "views/MonitorDashboard/MonitorDashboard.js";
import Manufacturer from "views/Manufacturer/Manufacturer.js";
import ResidentMap from "views/ResidentMap/ResidentMap.js";
import DeviceTable from "views/DeviceTable/DeviceTable.js";
import DeviceManagement from "views/DeviceManagement";
import AuditLogs from "views/AuditLogs/AuditLogs.js";
import DiagnosticPanel from "views/DiagnosticPanel";
import DeviceSettings from "views/DeviceSettings";
import Patient from "views/Patient/Patient.js";
import Company from "views/Company/Company.js";
import Devices from "views/Devices/Devices.js";
import { hasQueryParam } from "common/helpers";
import Observe from "views/Observe/Observe.js";
import Users from "views/Users/Users.js";
import ErrorLogs from "views/ErrorLogs";
import AlertLogs from "views/AlertLogs";
import GuestMap from "views/GuestMap";
import Facility from "views/Facility";
import Invites from "views/Invites";
import Reports from "views/Reports";

// @material-ui/icons
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BusinessIcon from "@material-ui/icons/Business";
import TimelineIcon from '@material-ui/icons/Timeline';
import RouterIcon from "@material-ui/icons/Router";
import PersonIcon from "@material-ui/icons/Person";
import PeopleIcon from "@material-ui/icons/People";
import DvrIcon from "@material-ui/icons/Dvr";
import TocIcon from '@material-ui/icons/Toc';

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Monitor Dashboard",
    roles: [
      "TenantAdmin",
      "PracticeAdmin",
      "SupplierAdmin",
      "SupplierUser",
      "PracticeUser",
      "Patient",
      "Guest"
    ],
    icon: DvrIcon,
    component: MonitorDashboard,
    layout: "/admin",
  },
  {
    path: "/table",
    name: "Device Data",
    roles: ["TenantAdmin"],
    icon: TocIcon,
    component: DeviceTable,
    layout: "/admin",
  },
  {
    name: "Device Table",
    roles: ["TenantAdmin"],
    icon: RouterIcon,
    path: "/device",
    component: Devices,
    layout: "/admin",
  },
  {
    path: "/manufacturer",
    name: "Manufacturer",
    roles: ["TenantAdmin"],
    icon: PersonIcon,
    component: Manufacturer,
    layout: "/admin",
  },
  {
    path: "/company",
    name: "Company",
    roles: ["TenantAdmin", "SupplierAdmin"],
    icon: BusinessIcon,
    layout: "/admin",
    component: Company,
  },
  {
    path: "/facility",
    name: "Facility",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin"],
    icon: BusinessIcon,
    layout: "/admin",
    component: Facility,
  },
  {
    path: "/resident",
    name: "Care Team",
    roles: ["TenantAdmin", "SupplierAdmin", "SupplierUser", "PracticeUser", "PracticeAdmin"],
    icon: PeopleIcon,
    component: Patient,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "User",
    roles: ["TenantAdmin", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser"],
    icon: PeopleIcon,
    component: Users,
    layout: "/admin",
  },
  {
    path: "/map-resident",
    roles: ["TenantAdmin"],
    name: "Resident Map",
    icon: AccountTreeIcon,
    component: ResidentMap,
    layout: "/admin",
  },
  {
    path: "/audit-logs",
    name: "Audit Logs",
    roles: ["TenantAdmin"],
    icon: AssessmentIcon,
    component: AuditLogs,
    layout: "/admin",
  },
  {
    path: "/error-logs",
    name: "Error Logs",
    roles: ["TenantAdmin"],
    icon: AssessmentIcon,
    component: ErrorLogs,
    layout: "/admin",
  },
  {
    path: "/observe",
    name: "Users",
    roles: [
      "Patient",
      "Guest"
    ],
    icon: PeopleIcon,
    component: Observe,
    layout: "/admin",
  },
  {
    path: "/alert-logs",
    name: "Alert Logs",
    roles: ["TenantAdmin", "TenantUser", "Patient",  "Guest", "PracticeUser", "PracticeAdmin", "SupplierAdmin", "SupplierUser", "Patient"],
    icon: VerticalSplitIcon,
    component: AlertLogs,
    layout: "/admin",
  },
  {
    path: "/diagnostic-panel",
    name: "Diagnostic Panel",
    roles: ["TenantAdmin"],
    icon: TimelineIcon,
    component: DiagnosticPanel,
    layout: "/admin",
  },
  {
    path: "/guest-map",
    name: "Guest Map",
    roles: ["TenantAdmin"],
    icon: DeveloperBoardIcon,
    component: GuestMap,
    layout: "/admin",
  },
  {
    path: "/invites",
    name: "Invites",
    roles: ["Guest"],
    icon: PeopleIcon,
    component: Invites,
    layout: "/admin",
  },
  {
    path: "/configuration",
    name: "Device Information",
    roles: [
      "TenantAdmin",
      "TenantUser"
    ],
    icon: DvrIcon,
    component: MonitorDashboard,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: "Device Settings",
    roles: ["TenantAdmin", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"],
    icon: DeveloperBoardIcon,
    component: DeviceSettings,
    layout: "/admin",
  },
  {
    path: "/management",
    name: "Device Migration",
    roles: ["TenantAdmin"],
    icon: RouterIcon,
    component: DeviceManagement,
    layout: "/admin",
  },
  {
    path: "/reports",
    name: "Reports",
    roles: ["TenantAdmin", "TenantUser"],
    icon: AssessmentIcon,
    component: Reports,
    layout: "/admin",
  }
];

if (hasQueryParam('showreport')) {
  dashRoutes.splice(dashRoutes.length - 2, 0, {
    path: "/reports",
    name: "Reports",
    roles: ["TenantAdmin", "TenantUser", "SupplierAdmin", "SupplierUser", "PracticeAdmin", "PracticeUser", "Patient"],
    icon: AssessmentIcon,
    component: Reports,
    layout: "/admin",
  });
}

export default dashRoutes;
